import { render, staticRenderFns } from "./VEmployeeProfile.vue?vue&type=template&id=48b2c9e8&scoped=true&lang=pug"
import script from "./VEmployeeProfile.vue?vue&type=script&lang=ts"
export * from "./VEmployeeProfile.vue?vue&type=script&lang=ts"
import style0 from "./VEmployeeProfile.vue?vue&type=style&index=0&id=48b2c9e8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b2c9e8",
  null
  
)

export default component.exports